<template>
  <address @click="$emit('click')">
    <div>{{value.first_name}} {{value.last_name}}</div>
    <span v-if="!isUSA && value.country_printable_name">
      {{value.country_printable_name}}<br>
    </span>
    {{value.line1}}<br>
    <template v-if="value.line2">{{value.line2}}<br></template>
    <template v-if="value.line3">{{value.line3}}<br></template>
    {{ value.city || value.line4 }}, {{value.state}} {{value.postcode}}
    <br>
  </address>
</template>
<script>
  import {isUSA} from '@/lib/CheckoutLogic';

  export default {
  props: ['value'],
  computed: {
    isUSA() {
      return isUSA(this.value.country);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Address.vue